package com.arena_web.ui.sections.dashboard

import androidx.compose.runtime.Composable
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

enum class DashboardSection {
    Analytics, Schedule
}

@Composable
fun DashboardSubNav(
    activeSection: DashboardSection,
    onSectionSelected: (DashboardSection) -> Unit
) {
    val t = LocalAppStrings.current
    Row(
        modifier = Modifier
            .sHeight(44)
            .sBorderRadius(22)
            .sPadding(4)
            .styleModifier {
                property("border", "0.3px solid transparent")
                property("background",
                    "${AppGradients.InteractiveSecondary} padding-box, " +
                    "linear-gradient(0deg, var(--l-s3, #060E1E), var(--l-s3, #060E1E)) padding-box, " +
                    "${AppGradients.ButtonBorderGradientPrimary} border-box")
                property("gap", s(2))
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        DashboardSection.entries.forEach { section ->
            val isActive = section == activeSection
            Box(
                modifier = Modifier
                    .sHeight(36)
                    .sBorderRadius(18)
                    .sPadding(0, 20)
                    .cursor(Cursor.Pointer)
                    .then(
                        if (isActive) Modifier.backgroundColor(AppColors.Primary)
                        else Modifier
                    )
                    .onClick { onSectionSelected(section) },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    when (section) {
                        DashboardSection.Analytics -> t.dashboardTabAnalytics
                        DashboardSection.Schedule -> t.dashboardTabSchedule
                    },
                    modifier = Modifier
                        .bodySMedium()
                        .color(if (isActive) org.jetbrains.compose.web.css.Color(AppColors.PrimaryWhite.toString()) else com.arena_web.ui.theme.ThemeVars.Text2)
                )
            }
        }
    }
}
